/**
 * ScrollToHash Component
 *
 * Handles scrolling to hash fragments when navigating with React Router.
 * Place this component inside the Router to enable hash-based scrolling.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToHash() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // If there's a hash, scroll to that element
    if (hash) {
      // Longer delay for lazy-loaded pages to fully render
      const timeoutId = setTimeout(() => {
        const elementId = hash.slice(1);
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          // Retry once more after additional delay for lazy-loaded content
          setTimeout(() => {
            const retryElement = document.getElementById(elementId);
            if (retryElement) {
              retryElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
          }, 300);
        }
      }, 150);

      return () => clearTimeout(timeoutId);
    }
    // No hash - scroll to top
    window.scrollTo({ top: 0, behavior: 'smooth' });
    return undefined;
  }, [pathname, hash]);

  return null;
}

export default ScrollToHash;
